export const CAMPAIGN_DATA_STORAGE_KEY = "utm";
export const FUNNEL_DATA_SESSION_STORAGE_KEY = "funnel";
export const FUNNEL_META_SESSION_STORAGE_KEY = "funnelMeta";
export const USER_SESSION_DATA_SESSION_STORAGE_KEY = "userSession";
export const USER_SESSION_DATA_LOCAL_STORAGE_KEY = "userSession";
